import emojilib from 'emojilib';

import { normalizeCode } from './utils';

export interface Emoji {
  emoji: string
  key: string
}

// Maps emoji, to a list of names/descriptions
export const emojiData = Object.entries(emojilib).map(
  ([emoji, names]) => [names, emoji] as const,
);

export const emojiCodesByName = new Map(emojiData.flatMap(([names, emoji]) => names.map(name => [name, emoji])))

export const emojiNamesByCode = new Map(
  emojiData.map(([names, emoji]) => [normalizeCode(emoji), names[0] as string]),
)
